import React from 'react';
import { useSelector } from 'react-redux';

export const useTableAnalysis = () => {
  const { favoriteQuestions, prompts, selectedDocuments, tableRows } = useSelector((state) => state.gridTableAnalysis);

  return React.useMemo(() => {
    return {
      favoriteQuestions,
      prompts,
      selectedDocuments,
      tableRows,
    };
  }, [favoriteQuestions, prompts, selectedDocuments, tableRows]);
};
